import { Col, Row } from "antd";
import { FixedSizeWrapper } from "./Layout";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "../Logo";
import { MenuButton } from "../Menu/MenuButton";
import { MenuDrawer } from "../Menu/MenuDrawer";
import { Search } from "../Search/Search";
import { selectCurrentUserReservations } from "../../../state/reservations/selectors";
import HpIcon, { Icons } from "react-hp-icons";
import React, { useEffect, useGlobal, useState } from "reactn";
import styled from "styled-components";
import { useAuth } from "hooks/useAuth";
const alwaysVisibleButtons = [
	{
		icon: null,
		isExternal: true,
		link: "https://comercial.zeroq.cl/inversionistas",
		shape: "round",
		text: "Inversionistas",
		type: "text",
		roundedOutline: true,
	},
	{
		icon: null,
		isExternal: true,
		link: "https://comercial.zeroq.cl/",
		text: "Hazte Cliente",
		type: "text",
	},
];
const visitVisibleButtons = [
	...alwaysVisibleButtons,
	{
		icon: null,
		link: "/signin",
		text: "Iniciar sesión",
		type: "text",
	},
	{
		icon: null,
		link: "/signup",
		text: "Regístrate",
		type: "text",
	},
];
const userVisibleButtons = (tickets, reserves, isLoggedInTemporary) => [
	...alwaysVisibleButtons,
	{
		icon: (
			<HpIcon
				type={Icons.ticket}
				badge={
					tickets.active.length && tickets.active.length.toString()
				}
				size={1.2}
				color="#fff"
				badgeSize="large"
			/>
		),
		link: "/my-tickets",
		text: "Mis Tickets",
		type: "text",
	},
	{
		icon: (
			<HpIcon
				type={Icons.calendar}
				badge={
					isLoggedInTemporary
						? reserves.length
							? reserves.length.toString()
							: 0
						: reserves.length && reserves.length.toString()
				}
				size={1.2}
				color="#fff"
				badgeSize="large"
			/>
		),
		link: "/my-reservations",
		text: "Mis Reservas",
		type: "text",
	},
];

const routesWithHiddenSearch = [
	"/welcome",
	"/signin",
	"/signup",
	"/logout",
	"/recover",
	"/password",
	"/terms",
];

export const Header = () => {
	const { isLoggedInTemporary, isLoggedIn } = useAuth();
	const [open, setOpen] = useState(false);
	const [global] = useGlobal();
	const {
		tickets,
		myReservations: { byId: reservesById },
		ticketsv2,
		user,
	} = global;
	const reserves =
		selectCurrentUserReservations(Object.values(reservesById)).filter(
			({ deleted }) => !deleted
		) || [];

	const location = useLocation();

	useEffect(() => {}, [location.pathname, tickets, reserves, user]);

	const showButtons = isLoggedIn || isLoggedInTemporary;
	return (
		<StyledHeader>
			<FixedSizeWrapper>
				<Row>
					<Col span={24} style={{ "z-index": "100" }}>
						<Row>
							<Col md={4} lg={6} xl={8}>
								<Link to="/home">
									<Logo width="148px"></Logo>
								</Link>
							</Col>
							<Col md={20} lg={18} xl={16}>
								<Row
									justify="end"
									align="middle"
									gutter={{ md: 2, lg: 12, xl: 24 }}
								>
									{showButtons &&
										userVisibleButtons(
											ticketsv2,
											reserves,
											isLoggedInTemporary
										).map((menuButton, i) => (
											<Col key={i}>
												<MenuButton
													place="header"
													menuButton={menuButton}
												></MenuButton>
											</Col>
										))}
									{!isLoggedIn &&
										!isLoggedInTemporary &&
										visitVisibleButtons.map(
											(menuButton, i) => (
												<Col key={i}>
													<MenuButton
														place="header"
														menuButton={menuButton}
													></MenuButton>
												</Col>
											)
										)}
									<Col>
										<MenuButton
											place="header"
											onClick={() => setOpen(true)}
											menuButton={{
												type: "text",
												action: "openDrawer",
												icon: (
													<HpIcon
														onClick={() =>
															setOpen(true)
														}
														type={Icons.menu}
														size={1.4}
														color="#fff"
													/>
												),
											}}
										></MenuButton>
									</Col>
								</Row>
							</Col>
						</Row>
						{!routesWithHiddenSearch.includes(
							location.pathname
						) && (
							<Row justify="center" align="middle">
								<Col span={24}>
									<Search></Search>
								</Col>
							</Row>
						)}
					</Col>
				</Row>
				<MenuDrawer open={open} setOpen={setOpen}></MenuDrawer>
			</FixedSizeWrapper>
		</StyledHeader>
	);
};

const StyledHeader = styled.div`
	color: #fff;
	padding: 1.5rem;
	background-color: #145ab4;
	background-image: linear-gradient(400deg, #145ab4, #490c6e);
	max-height: 338px;
`;
